/* @flow */

import classNames from 'classnames';
import * as React from 'react';
import { useIntl } from 'react-intl';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';
import styles from './MarketCreateTopicCard.style';
import messages from 'src/shared/domain/topic/l10n/topicL10n';

import Steps from 'src/shared/ui/component/steps/Steps/Steps';
import Step from 'src/shared/ui/component/steps/Step/Step';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

type Props = {
  className?: string,
};

const useStyles = createUseThemeStyles(styles);

const MarketCreateTopicCard = ({ className }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */
  const intl = useIntl();

  /*
   |----------------------------------------------------------------------------
   | State
   |----------------------------------------------------------------------------
   */

  /*
   |----------------------------------------------------------------------------
   | Effects
   |----------------------------------------------------------------------------
   */

  React.useEffect(() => {}, []);

  /*
   |----------------------------------------------------------------------------
   | Event Handlers
   |----------------------------------------------------------------------------
   */

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles();
  const rootClasses = classNames([classes.root, className]);

  const separatorColor = ({ theme }: ThemeFunction) => theme.accentColor;

  const steps = [
    {
      id: 'step1',
      label: intl.formatMessage(messages.topicCreationStep1StepLabel),
    },
    {
      id: 'step2',
      label: intl.formatMessage(messages.topicCreationStep2StepLabel),
    },
    {
      id: 'step3',
      label: intl.formatMessage(messages.topicCreationStep3StepLabel),
    },
  ];

  /*
   |----------------------------------------------------------------------------
   | Refs
   |----------------------------------------------------------------------------
   */

  return (
    <div className={rootClasses}>
      <Steps className={classes.stepperSteps}>
        {steps.map(({ id, label }) => (
          <Step
            isDisabled
            key={id}
            label={label}
            hasArrow
            separatorColor={separatorColor}
            circleClassName={classes.stepCircle}
            labelClassName={classes.stepLabel}
          />
        ))}
      </Steps>
    </div>
  );
};

export default React.memo<Props>(MarketCreateTopicCard);
